const state = {
  layout: 'light'
};
export default state;